module.exports = __webpack_public_path__ + "static/media/iguazu-falls-32.2684c0ff.jpg";